export default __webpack_public_path__ + "static/media/instruction_step_2.95a6a6fc.png";